export default __webpack_public_path__ + "static/media/Stage2_clueicon_correct.a1ba1d52.svg";